<template>
<span id="delete-all" v-if="isVisible()">
  <el-button
    id="btn-delete-all"
    type="success" plain
    @click="handleDeleteAll()"
    size="mini"
    v-show="displayButton"
  >
    {{ $t('outbound.units.deleteAll') }}
  </el-button>
</span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { Message } from 'element-ui';
import moment from 'moment';
import constants from '@/utils/constants';
import { OUTBOUND_UNITS_DELETE_ALL, OUTBOUND_UNITS_SEARCH, OUTBOUND_UNITS_VALIDATE_DELETE_ALL } from '@/store/actions';

export default {
  name: 'DeleteAll',
  props: {
    displayButton: Boolean,
  },
  computed: {
    ...mapGetters([
      'outboundUnits'
    ])
  },
  methods: {
    ...mapActions({
      validateDeleteAll: OUTBOUND_UNITS_VALIDATE_DELETE_ALL,
      deleteAll: OUTBOUND_UNITS_DELETE_ALL,
      search: OUTBOUND_UNITS_SEARCH,
    }),
    isVisible() {
      const hasDeleteAllUnitsPermission = this.$can(this.permissions.DATA_ENTRY.DELETE_ALL_UNITS);
      const thereAreRowsInGrid = this.outboundUnits.list.length > 0;
      return hasDeleteAllUnitsPermission && thereAreRowsInGrid && this.outboundUnits.actualFilters.active;
    },
    async confirmValidation() {
      let validationConfirm = false;
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      const validationResponse = await this.validateDeleteAll().catch(() => {
      });
      if (validationResponse > 0) {
        const dosFrom = this.outboundUnits.actualFilters.dayOfServiceFrom;
        const dosTo = this.outboundUnits.actualFilters.dayOfServiceTo
          ? this.outboundUnits.actualFilters.dayOfServiceTo : this.outboundUnits.actualFilters.dayOfServiceFrom;

        validationConfirm = await this.$confirm(
          this.$t('outbound.units.deleteAllConfirm')
            .replace('[numberOfUnits]', validationResponse)
            .replace('[shipDateFrom]', moment(dosFrom).format(constants.DATES.DEFAULT_DISPLAY_FORMAT))
            .replace('[shipDateTo]', moment(dosTo).format(constants.DATES.DEFAULT_DISPLAY_FORMAT)),
          { confirmButtonText: this.$t('outbound.units.deleteAll'), dangerouslyUseHTMLString: true }
        ).catch(() => {
        });
      }
      loading.close();
      return validationConfirm;
    },
    async handleDeleteAll() {
      Message.closeAll();

      // Check number units to delete
      const confirm = await this.confirmValidation();
      if (!confirm) {
        return;
      }

      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      try {
        const response = await this.deleteAll().catch(() => {});
        this.$message.success(response.message);
        this.search({});
        this.dialogVisible = false;
      } finally {
        loading.close();
      }
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#delete-all #btn-delete-all {
  margin-right: 10px;
}
</style>
